const DISPLAY_SEARCH_CLASS = 'addsearch';

document.addEventListener("DOMContentLoaded", searchTabsInit, false);
document.addEventListener("shopify:section:load", searchTabsInit, false);
document.addEventListener("DOMContentLoaded", speechInit, false);
document.addEventListener("shopify:section:load", speechInit, false);

// Store original content for multiple search instances
const originalContents = new Map();

// Store original content on page load
document.addEventListener("DOMContentLoaded", storeAllOriginalContent, false);
document.addEventListener("shopify:section:load", storeAllOriginalContent, false);

function storeAllOriginalContent() {
    // Store original content for all search container instances
    const searchContainers = document.querySelectorAll('.search-container-popular-products');
    searchContainers.forEach((container, index) => {
        const id = container.id || `search-container-${index}`;
        originalContents.set(id, container.innerHTML);
    });

    // Also store for popular-courses-grid if it exists separately
    const popularCourseGrids = document.querySelectorAll('.popular-courses-grid');
    popularCourseGrids.forEach((grid, index) => {
        const id = grid.id || `popular-grid-${index}`;
        originalContents.set(id, grid.innerHTML);
    });
}

function restoreAllOriginalContent() {
    // Restore all search container instances
    const searchContainers = document.querySelectorAll('.search-container-popular-products');
    searchContainers.forEach((container, index) => {
        const id = container.id || `search-container-${index}`;
        const originalContent = originalContents.get(id);
        if (originalContent) {
            container.innerHTML = originalContent;
        }
    });

    // Also restore all popular-courses-grid if they exist separately
    const popularCourseGrids = document.querySelectorAll('.popular-courses-grid');
    popularCourseGrids.forEach((grid, index) => {
        const id = grid.id || `popular-grid-${index}`;
        const originalContent = originalContents.get(id);
        if (originalContent) {
            grid.innerHTML = originalContent;
        }
    });
}

let $resultsBox = $('.yv-search-result-container');
let searchbarresult = $('body').find('.yv-header-searchbar-content');
let originalPopularProductsHTML = '';

$(document).ready(function() {
    const popularProductsContainer = document.querySelector('.search-container-popular-products');
    if (popularProductsContainer) {
        originalPopularProductsHTML = popularProductsContainer.innerHTML;
    }
});

function removeHtmlEntities(str) {
    const htmlEntities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;"
    };
    return str.replace(/([&<>\"'])/g, match => htmlEntities[match]);
}

function searchTabsInit() {
    recentSearch();
    var tabHead = document.getElementsByClassName('yv-tab-result-head');
    if (tabHead.length > 0) {
        var tabContent = document.getElementsByClassName('yv-search-result-list');
        Array.from(tabHead).forEach(function(btn) {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                Array.from(tabHead).forEach(function(item) {
                    item.classList.remove('active');
                });
                let searchUrl = btn.getAttribute("data-resulturl");
                let searchContainer = document.querySelector('.search-bar-container');
                if (searchContainer) {
                    let allresultLink = searchContainer.querySelector('.search-result-bottom');
                    if (searchContainer) {
                        allresultLink.setAttribute('href', searchUrl);
                    }
                }
                Array.from(tabContent).forEach(function(item) {
                    item.classList.remove('active');
                });
                btn.classList.add("active");
                var _value = btn.getAttribute("data-results");
                document.getElementById(_value).classList.add("active");
            });
        });
    }
}

function showSearch() {
    $('body').addClass(DISPLAY_SEARCH_CLASS)
    $('input.search-input').trigger('focus');
    $('#recent_search_list').html('');
    recentSearch();
    focusElementsRotation($('.search-bar-container'));
}

function hideSearch() {
    $('body').removeClass(DISPLAY_SEARCH_CLASS);
}

var searchTyping;
$(document).ready(function() {

    // 1) Check if there's a 'q' param in the URL (i.e. user came directly to a search page)
    var urlParams = new URLSearchParams(window.location.search);
    var qParam = urlParams.get('q');
    if(qParam && qParam.trim().length > 2){
        saveSearchPhrase(qParam.trim());
    }

    // Any element with the data-dismiss-search attribute will close the active search drawer to prevent overlapping panels.
    $('[data-dismiss-search]').on('click', hideSearch);

    $('.header-search-icon').on('click', function(e) {
        e.preventDefault();
        focusElement = $('.search-form');

        if ($('body').hasClass(DISPLAY_SEARCH_CLASS)) {
            hideSearch();
        } else {
            showSearch();
        }
    });

    /// AjaX Product Search
    $('.AjaxSearchResponse').prepend('');
    $('.search-close').show();

    $('body').on('keydown', '.search-input', function(e) {
        clearTimeout(searchTyping);
        if (this.value.length === 0 && e.which === 32) e.preventDefault();
    });
    $('body').on('keyup', '.search-input', function(e) {
        clearTimeout(searchTyping);
        var _this = $(this);
        searchResults(_this);
    });

    // Store search phrase on form submission
    $('.search-form, #search-form').on('submit', function(e) {
        e.preventDefault();
        var term = $(this).find('input[name="q"]').val();
        if (term.length > 2) {
            saveSearchPhrase(term);
        }
        var linkURL = $(this).attr('action') + '?q=*' + term + '*&options%5Bprefix%5D=last';
        window.location = linkURL;
    });
    // get handler on form action="/search"
    $('.search-bar-container form[action="/search"]').on('submit', function(e) {
        // e.preventDefault();
        var term = $(this).find('input[name="q"]').val();
        if(term.length < 1){
            e.preventDefault();
            return;
        }
        // var linkURL = $(this).attr('action') + '?q=*' + term + '*&options%5Bprefix%5D=last';
        // window.location = linkURL;
    });
    $('.yv-search-drawer-close').on('click', function(e) {
        e.preventDefault();
        $('input.form-control.search-input').val('');
        $resultsBox.empty();
        $('body').removeClass('addsearch');
        // Restore all containers to original state
        restoreAllOriginalContent();
        stopFocusElementsRotation();
        focusElement.trigger('focus');
    });

    $('body').on('click', '.yv-search-bar', function(e) {
        if($(this).val().length > 2){
            $('.yv-header-searchbar-content').show();
        }
    });

    $(document).on("focus","button[data-searchbar-cross]",function(e) {
        e.preventDefault();
        $(this).hide();
        $(".yv-search-bar").val("");
        searchbarresult.hide();
        searchbarresult.html("");
    });

    // Store search phrase when a result is clicked
    $(document).on('click', '.search-result-item a', function() {
        var searchTerm = $('.search-input').val();
        if (searchTerm && searchTerm.length > 2) {
            saveSearchPhrase(searchTerm);
        }
    });
});

// New function to save search phrases
function saveSearchPhrase(phrase) {
    var storedSearches = localStorage.getItem("Recent_search_phrases");
    var storedSearchesArray = JSON.parse(storedSearches);

    if (storedSearchesArray == null) {
        storedSearchesArray = [];
    }

    // Don't store duplicate phrases
    if (!storedSearchesArray.includes(phrase)) {
        // Add the new phrase
        storedSearchesArray.push(phrase);

        // Keep only the most recent 20 searches
        if (storedSearchesArray.length > 20) {
            storedSearchesArray.shift(); // Remove the oldest search
        }

        // Save back to localStorage
        localStorage.setItem("Recent_search_phrases", JSON.stringify(storedSearchesArray));
    }
}

function clearRecent(element){
    localStorage.removeItem("Recent_search_phrases");

    // Find the closest recent search list to the clicked button
    if(element) {
        const recentList = $(element).closest('.recent-search-container').find('.recent-search-listing');
        recentList.html('');
        recentList.siblings('.yv-search-result-container').addClass('no-recent');
        $('.recent-search-list').html('');
    } else {
        // For backward compatibility, clear all instances
        $('.recent-search-list').html('');
        $('.recent-search-list').siblings('.yv-search-result-container').addClass('no-recent');
    }
}

function recentSearch() {
    // Process all recent search containers
    $('.search-container').each(function() {
        const $container = $(this);
        const $recentList = $container.find('.recent-search-list');
        const $resultsContainer = $container.find('.yv-search-result-container');

        $recentList.html('');
        $resultsContainer.removeClass('no-recent');

        setTimeout(function() {
            // Get search phrases from localStorage
            var storedSearches = localStorage.getItem("Recent_search_phrases");
            var storedSearchesArray = JSON.parse(storedSearches);

            if (!storedSearchesArray || storedSearchesArray.length === 0) {
                $recentList.html('');
                $resultsContainer.addClass('no-recent');
            } else {
                var recent_Html = '';

                const clearSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M1 3.17969H13" stroke="#000054" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.22683 1H5.77228C5.55529 1 5.34718 1.0862 5.19374 1.23964C5.0403 1.39308 4.9541 1.60119 4.9541 1.81818V3.18182H9.04501V1.81818C9.04501 1.60119 8.95881 1.39308 8.80537 1.23964C8.65193 1.0862 8.44382 1 8.22683 1Z" stroke="#000054" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.77246 10.1378V6.04688" stroke="#000054" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.22754 10.1378V6.04688" stroke="#000054" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10.7418 12.2451C10.7266 12.4501 10.6344 12.6417 10.4836 12.7814C10.3328 12.9211 10.1346 12.9984 9.92909 12.9979H4.07091C3.86536 12.9984 3.66724 12.9211 3.51644 12.7814C3.36564 12.6417 3.27336 12.4501 3.25818 12.2451L2.5 3.17969H11.5L10.7418 12.2451Z" stroke="#000054" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
                recent_Html = recent_Html.concat('<div class="flex"><h6 class="recent-search-title">' + searchRecentTitleText + '</h6>');
                recent_Html = recent_Html.concat('<button type="button" class="clear-recent-searches" onclick="clearRecent(this)">Clear</button></div>');
                recent_Html = recent_Html.concat('<ul class="list-unstyled recent-search-listing">');

                // Reverse to show most recent searches first
                var recentSearches = storedSearchesArray.reverse();

                // Display each search phrase directly
                $.each(recentSearches, function(index, phrase) {
                    if (index < 10) {
                        // Create search URL with the phrase
                        var encodedPhrase = encodeURIComponent(phrase);
                        var searchUrl = '/search?q=' + encodedPhrase;
                        recent_Html += `<li><a class="focus-inside search-link" href="${searchUrl}">${truncate(removeHtmlEntities(phrase), 5)}</a></li>`;
                    }
                });

                recent_Html = recent_Html.concat('</ul>');
                $recentList.html(recent_Html);
            }
        }, 500);
    });

    focusElementsRotation($('.search-bar-container'));
}

function fetchPredictivePopularCourses(term) {
    let resultType = 'product';

    fetch(
        searchUrl + '/suggest?section_id=predictive-results&q='
        + encodeURIComponent(term)
        + '&resources[type]=' + resultType
        + '&resources[options][fields]=author,tag,title,product_type,variants.title,vendor,variants.sku'
    )
        .then((response) => response.text())
        .then((resultHtml) => {
            let parsedDoc = new DOMParser().parseFromString(resultHtml, 'text/html');
            let resultsSection = parsedDoc.querySelector('#shopify-section-predictive-popular-courses');
            let resultsProductCard = parsedDoc.querySelector('.popular-course-item');

            // console.log('Predictive search results: ', resultsSection);

            const searchContainers = document.querySelectorAll('.search-container-popular-products');
            searchContainers.forEach((container, index) => {
                const id = container.id || `search-container-${index}`;
                if (resultsProductCard && resultsSection) {
                    // Insert the HTML from the section into the grid
                    container.innerHTML = resultsSection.innerHTML;
                } else {
                    // If no results found, restore original content
                    const originalContent = originalContents.get(id);
                    if (originalContent) {
                        container.innerHTML = originalContent;
                    } else if (originalPopularProductsHTML) {
                        container.innerHTML = originalPopularProductsHTML;
                    }
                }
            });

            const popularCourseGrids = document.querySelectorAll('.popular-courses-grid');
            popularCourseGrids.forEach((grid, index) => {
                const id = grid.id || `popular-grid-${index}`;
                if (resultsProductCard && resultsSection) {
                    grid.html = resultsSection.innerHTML;
                } else {
                    const originalContent = originalContents.get(id);
                    if (originalContent) {
                        grid.innerHTML = originalContent;
                    } else if (originalPopularProductsHTML) {
                        grid.innerHTML = originalPopularProductsHTML;
                    }
                }
            });
        })
        .catch((err) => {
            console.error('Predictive search fetch error: ', err);
            restoreAllOriginalContent();
        });
}

function searchResults(inputField) {
    var section_id = '';
    var _drawer = $('[data-search-drawer]').data('search-drawer');
    var _searchContainer = $('body').find('.search-bar-container');
    var $form = inputField.closest('form');

    searchTyping = setTimeout(function() {
        $resultsBox.html(preLoadLoadGif);

        var term = $form.find('input[name="q"]').val();
        var resultType = 'product';
        if (searchPageResults) {
            resultType += ',page';
        }
        if (searchArticleResults) {
            resultType += ',article';
        }
        if (searchSuggestions) {
            resultType += ',query';
        }

        handleSeeAllResults(term);

        if (inputField.hasClass("yv-search-bar")) {
            searchbarresult.show();
            searchbarresult.html(preLoadLoadGif);
            section_id = 'predictive-search-lite';
        } else {
            section_id = 'predictive-search';
        }

        if (term.length > 2 && term != inputField.data('oldval')) {
            if (inputField.hasClass("yv-search-bar")) {
                $("button[data-searchbar-cross]").show();
            }

            fetch(
                searchUrl + "/suggest?section_id=" + section_id
                + "&q=" + term
                + "&resources[type]=" + resultType
                + "&resources[options][fields]=author,tag,title,product_type,variants.title,vendor,variants.sku"
            )
                .then((response) => response.text())
                .then((resultHtml) => {
                    let results = new DOMParser()
                        .parseFromString(resultHtml, 'text/html')
                        .querySelector('#shopify-section-' + section_id);

                    if (inputField.hasClass("yv-search-bar")) {
                        if (results) {
                            searchbarresult.html(results.innerHTML);
                        }
                    } else {
                        if (_searchContainer.find('[data-search-suggestions]').length > 0) {
                            if (results && results.querySelector('[data-search-suggestions]')) {
                                _searchContainer.find('[data-search-suggestions]').html(
                                    results.querySelector('[data-search-suggestions]').innerHTML
                                );
                                results.querySelector('[data-search-suggestions]').innerHTML = '';

                                _searchContainer.find('.popular-searches').hide();
                            } 
                        }

                        if ($('.no-result-for-search').length > 0) {
                            $('.popular-searches').show();
                        }
                        if (results) {
                            $resultsBox.html(results.innerHTML);
                            searchTabsInit();
                        } else {
                            // No results at all -> Restore original + show popular
                            restoreAllOriginalContent();
                            _searchContainer.find('.popular-searches').show(); // <--- ADD
                        }

                        focusElementsRotation($('.search-bar-container'));
                    }

                    if (_drawer) {
                        fetchPredictivePopularCourses(term);
                    }
                })
                .catch((error) => {
                    console.error('Search fetch error:', error);
                    // On error, restore all containers + show popular
                    restoreAllOriginalContent();
                    _searchContainer.find('.popular-searches').show(); // <--- ADD
                    focusElementsRotation($('.search-bar-container'));
                });
        }
        else if (term.length <= 2) {
            // Term too short or empty => restore original, remove suggestions, show popular
            restoreAllOriginalContent();

            // Clear any leftover "sorry" or suggestions
            _searchContainer.find('[data-search-suggestions]').empty(); // <--- ADD
            _searchContainer.find('.popular-searches').show();          // <--- ADD

            searchbarresult.empty();
            $("button[data-searchbar-cross]").hide();
            searchbarresult.css("display","none");

            focusElementsRotation($('.search-bar-container'));
        }
    }, 200);
}

function speechInit() {
    let searchBySpeechs = document.querySelectorAll("[data-speech-search]");
    Array.from(searchBySpeechs).forEach(function (searchBySpeech) {
        initSpeectRecognition(searchBySpeech);
    });
}

function initSpeectRecognition(searchSpeech) {
    let speechRecognition = null;
    let listening = false;
    let searchInput = null;
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
        "webkitSpeechRecognition" in window &&
        userAgent.indexOf("chrome") > -1 &&
        !!window.chrome &&
        userAgent.indexOf("edg/") === -1
    ) {
        searchSpeech.classList.remove("hidden");
        speechRecognition = new window.webkitSpeechRecognition();
        speechRecognition.continuous = false;
        speechRecognition.interimResults = false;
        searchInput = searchSpeech.closest("form").querySelector("[data-search-input]");

        speechRecognition.addEventListener(
            "result",
            debounce((evt) => {
                if (evt.results) {
                    const term = evt.results[0][0].transcript;
                    searchInput.value = term;
                    searchInput.focus();
                    searchInput.dispatchEvent(new Event("input"));
                    searchResults($(searchInput));

                    // Store speech search phrase too if user triggered it
                    if (term.length > 2) {
                        saveSearchPhrase(term);
                    }
                }
            }, 300)
        );

        speechRecognition.addEventListener("audiostart", () => {
            listening = true;
            searchSpeech.classList.add("active");
        });

        speechRecognition.addEventListener("audioend", () => {
            listening = false;
            searchSpeech.classList.remove("active");
        });

        searchSpeech.addEventListener("click", function (evt) {
            evt.preventDefault();
            if (listening) {
                speechRecognition.stop();
                listening = false;
            } else {
                speechRecognition.start();
                listening = true;
            }
        });

        searchSpeech.addEventListener("keydown", (evt) => {
            if (evt.code === "Space" || evt.code === "Enter") {
                evt.preventDefault();
                if (listening) {
                    speechRecognition.stop();
                } else {
                    speechRecognition.start();
                }
            }
        });
    }
}

function handleSeeAllResults(term) {
    const seeAllDiv = document.querySelector('.see-all-results');
    if (!seeAllDiv) return;

    // For clarity, we also fetch the link inside .see-all-results
    const seeAllLink = seeAllDiv.querySelector('.see-all-results-link');
    if (!seeAllLink) return;

    // If typed query is at least 3 chars, show the container and update the link
    if (term && term.trim().length >= 3) {
        seeAllDiv.style.display = 'flex';
        seeAllLink.href = '/search?q=' + encodeURIComponent(term) + '&options[prefix]=last';
    } else {
        // Otherwise hide
        seeAllDiv.style.display = 'none';
        seeAllLink.href = '/search?q=';
    }
}
